import React from 'react';
import {
  Box,
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Toolbar,
  Typography,
} from '@mui/material';
import DocuCheckTableHead from './DocuCheckTableHead';

function DocuCheckSkeleton() {
  const handleSelectAll = () => {};

  return (
    <Box pt={1}>
      <Stack direction="row" alignItems="center" mb={3}>
        <Typography variant="pageTitle">Docu-Check</Typography>
        <Skeleton variant="circular" width={20} height={20} sx={{ ml: 1 }} />
      </Stack>

      <Paper>
        <Toolbar className="justify-content-between border-bottom">
          <Box display="flex" gap={2} sx={{ width: '50%' }} />
          <Stack direction="row" spacing={2}>
            <Skeleton variant="rounded" width={150} height={36} />
          </Stack>
        </Toolbar>

        <TableContainer sx={{ overflowX: 'auto' }}>
          <Table sx={{ tableLayout: 'fixed', minWidth: 650 }}>
            <DocuCheckTableHead handleSelectAll={handleSelectAll} disabled checked={false} />
            <TableBody>
              {Array.from({ length: 3 }).map((_, index) => (
                <TableRow key={index}>
                  <TableCell>
                    <Stack direction="row" alignItems="center" gap={2}>
                      <Skeleton animation="wave" variant="circular" width={24} height={24} />
                      <Skeleton animation="wave" variant="text" width="70%" height={24} />
                    </Stack>
                  </TableCell>
                  <TableCell>
                    <Skeleton animation="wave" variant="text" width="80%" height={24} />
                  </TableCell>
                  <TableCell>
                    <Skeleton animation="wave" variant="text" width="70%" height={24} />
                  </TableCell>
                  <TableCell>
                    <Skeleton animation="wave" variant="text" width="60%" height={24} />
                  </TableCell>
                  <TableCell align="right" sx={{ pr: 2 }}>
                    <Stack direction="row" gap={1} justifyContent="flex-end">
                      <Skeleton animation="wave" variant="circular" width={20} height={20} />
                      <Skeleton animation="wave" variant="circular" width={20} height={20} />
                      <Skeleton animation="wave" variant="circular" width={20} height={20} />
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
}

export default DocuCheckSkeleton;
